import { render, staticRenderFns } from "./UserCreationModal.vue?vue&type=template&id=23a24dcb&scoped=true"
import script from "./UserCreationModal.vue?vue&type=script&lang=js"
export * from "./UserCreationModal.vue?vue&type=script&lang=js"
import style0 from "./UserCreationModal.vue?vue&type=style&index=0&id=23a24dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a24dcb",
  null
  
)

export default component.exports